export default "__VITE_ASSET__DcoC6Kjf__"